import React from 'react';
import Statebar from './Statebar';
import Attachments from '../Components/Attachments';
import Header from './Header'
import TaskComment from './TaskComment';
import InfoTooltip from '../Components/InfoTooltip';
import { attachments, tooltipTexts, description } from './data'
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition } from '../Components/Transitions';
import store from './state';
import { I18n } from 'react-i18next';

import block from 'bem-cn-lite';

block.setup({
    mod: '--',
});

class CustomWorkflow extends React.Component {
    constructor(props) {
        super(props)

        this.onStatusChange = this.onStatusChange.bind(this)
    }

    onStatusChange(id) {

        this.props.setGlobalState({
            currentStatus: id,
            step: this.props.step + 1
        })
    }
    
    render() {
        const b = block('CustomWorkflow');
        var tooltipText = '';

        switch(this.props.step) {
            case 0:
                tooltipText = tooltipTexts.change
                break;

            case 1:
                tooltipText = tooltipTexts.complete
                break;
            
            case 2:
                tooltipText = tooltipTexts.done
                break;

            case 3:
                tooltipText = tooltipTexts.doneInstance
                break;
            default:
            break;
        }

        return (
            <I18n ns={ ['customWorkflow'] }>
            {
                (t, { i18n }) => (
                <div className={b()}>
                    <InfoTooltip text={tooltipText} />
                    <Header title={t('customWorkflow:title')} />
                    <div className={b('statebar')}>
                        <Statebar 
                            status={this.props.currentStatus} 
                            onStatusChange={this.onStatusChange} 
                            initials={t('customWorkflow:assigneeInitials')}
                            assigneeName={t('customWorkflow:assigneeName')}
                            author={t('customWorkflow:author')}
                        />
                    </div>

                    <div className={b('description')} dangerouslySetInnerHTML={description}></div>

                    <div className={b('attachments')}>
                        <Attachments attachments={attachments}/>
                    </div>

                    <div className={b('comments')}>
                        <TransitionGroup
                            component="div"
                        >
                            {this.props.step > 0 && 
                                <FadeTransition>
                                    <TaskComment/>
                                </FadeTransition>
                            }
                        </TransitionGroup>
                        
                    </div>
                </div>
                )
            }
            </I18n>
        )
    }
}

export default store(CustomWorkflow)